(function() {

	var QuickOrderPage = function() {
		this.initAutocomplete();
	};

	QuickOrderPage.prototype = {
		initAutocomplete: function() {
			var engine = new Bloodhound({
				name: 'products-engine',
				remote: {
					url: 'api/products.json?part_number_match=%QUERY&results=5&active=1',
					wildcard: '%QUERY',
					transform: function(response) {
						return response.products;
					}
				},
				datumTokenizer: function(d) {
					return Bloodhound.tokenizers.whitespace(d.val);
				},
				queryTokenizer: Bloodhound.tokenizers.whitespace
			});

			engine.initialize();

			$('.part-number input').typeahead({
				minLength: 1,
				highlight: true
			},
			{
				name: 'products-dataset',
				source: engine.ttAdapter(),
				displayKey: 'part_number',
				limit: 100, // HACK: results don't get displayed in certain circumstances without this
				templates: {
					// Format the suggestions
					suggestion: function(result) {
						return '<p>' + result.part_number + "</p>";
					}
				}
			});
		}

	};

	C.QuickOrderPage = QuickOrderPage;

})();
